'use strict';

/* global $ */

class Aks {
    constructor() {
        this.init();
    }
    init() {
        console.log('[ Aks ] init');

        this.jsAkssesInputChange();
        this.jsAkssesMinus();
        this.jsAkssesPlus();
        this.jsNumberBox();
    }
    jsAkssesInputChange() {
      $('.js-aksses-input[type="checkbox"]').on('change', function(){
        $(this).parents('.js-aksses').toggleClass('aksses__item--active');
      });
      $('.js-aksses-input[type="radio"]').on('change', function(){
        $(this).parents('.js-aksses').parent().find('.js-aksses-input[type="radio"]').each(function(){
          if($(this).prop('checked') == false) {
            $(this).parents('.js-aksses').removeClass('aksses__item--active');
          }
        })
        $(this).parents('.js-aksses').toggleClass('aksses__item--active');
      });
    }
    jsAkssesMinus() {
      $('.js-aksses .js-aks-min').click(function(){
        // if (Number($(this).siblings('input').val()) > 0) {
        //   $(this).siblings('input').val(Number($(this).siblings('input').val()) - 1);
        // }
        if ($(this).parents('.js-aksses')) {
          if (Number($(this).siblings('input').val()) > 0) {
            $(this).siblings('input').val(Number($(this).siblings('input').val()) - 1);
            $(this).parents('.js-aksses').find('.js-aksses-input').val(Number($(this).siblings('input').val()) * Number($(this).parents('.js-aksses').find('.js-aksses-input').data('price')));
			if (Number($(this).siblings('input').val()) == 0) {
				$(this).parents('.js-aksses').find('.js-aksses-input').prop('checked', false);
				$(this).parents('.js-aksses').removeClass('aksses__item--active');
			}
            console.log('3');
          }
        }
      })
    }
    jsAkssesPlus() {
      $('.js-aksses .js-aks-plus').click(function(){
        // if ($(this).siblings('input').val() < 999) {
        //   $(this).siblings('input').val(Number($(this).siblings('input').val()) + 1);
        // }
        if ($(this).parents('.js-aksses')) {
          if (Number($(this).siblings('input').val()) < 999) {
            $(this).siblings('input').val(Number($(this).siblings('input').val()) + 1);
            $(this).parents('.js-aksses').find('.js-aksses-input').val(Number($(this).siblings('input').val()) * Number($(this).parents('.js-aksses').find('.js-aksses-input').data('price')));
             console.log('34');
          }
        }
      })
    }
    jsNumberBox() {
      $('.js-number-box').on('keyup',function(){
        $(this).parents('.js-aksses').find('.js-aksses-input').val(Number($(this).parents('.js-aksses').find('.js-aksses-input').data('price')) * Number($(this).val()));
		if (Number($(this).val()) == 0) {
			$(this).parents('.js-aksses').find('.js-aksses-input').prop('checked', false);
			$(this).parents('.js-aksses').removeClass('aksses__item--active');
		}
      })
    }
};

export {
    Aks
};
